import { Button, StaticMenuLayout, VText } from '@vake/ui-kit';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { formatUtc } from '../../../shared/components/time';
import { Flag, MagnifyingGlass } from '@phosphor-icons/react';
import FlagChangeButton from '../../../shared/components/FlagChangeButton';

export const PathfinderLeftSidebar: FC<{
    reportName: string | undefined;
    mmsi: string | null;
    shipImo: string | null;
    fromDate: string;
    toDate: string;
    havePlanet: boolean;
    hasOilPipelines: boolean;
    firstLastAISMessage: FlagChangeProps | null;
}> = ({ reportName, mmsi, shipImo, fromDate, toDate, firstLastAISMessage }) => {
    const [enableGetFlagDetection, setEnableGetFlagDetection] = useState<boolean>(false);
    const handleFlagChangePress = () => {
        setEnableGetFlagDetection(true);
    };

    return (
        <div className="absolute flex flex-col z-10 left-2 my-2">
            <StaticMenuLayout
                menuChildren={
                    <div className="flex flex-col gap-2">
                        <Link to="/pathfinder-reports">
                            <VText variant="B2">Back to Reports</VText>
                        </Link>
                    </div>
                }
                title={reportName ? reportName : `MMSI: ${mmsi}`}
            >
                <div className="flex flex-col gap-2 p-3">
                    <VText variant="D1B">Vessel of interest</VText>
                    <VText>MMSI: {mmsi} </VText>
                    <VText>IMO: {shipImo}</VText>
                    <VText>From: {formatUtc(new Date(fromDate))}</VText>
                    <VText>To: {formatUtc(new Date(toDate))}</VText>
                </div>
            </StaticMenuLayout>
            {/* {!enableGetFlagDetection ? (
                <Button
                    iconBefore={<Flag />}
                    text="Detect Flag Change"
                    variant="neutral"
                    iconAfter={<MagnifyingGlass />}
                    onClick={handleFlagChangePress}
                /> // <Flag className="cursor-pointer" size={20} onClick={handleFlagChangePress} />
            ) : (
                <FlagChangeButton mmsi={mmsi} timePoint={firstLastAISMessage} />
            )} */}
        </div>
    );
};
